import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { bannerReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { BannerEffects } from './effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('banner', bannerReducer),
    EffectsModule.forFeature([
      BannerEffects
    ])
  ]
})
export class BannerStoreModule { }